/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-08-14 14:08:22
 * @FilePath: /dbrank_b/src/routes/visualChart/P2/index.js
 * @Description: p2
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import DBTable from '../components/DBTable';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title1 } from '../components/Titles';
import Form from './Form';
import TooltipDrawer from '../components/TooltipDrawer';


const positionList = [
  [{ x: 30, y: 0, w: 600 }],
  [{ x: 30, y: 160, w: 300 }, { x: 360, y: 160, w: 300 }],
  [{ x: 30, y: 0, w: 300 }, { x: 360, y: 0, w: 300 }, { x: 200, y: 320, w: 300 }],
  [{ x: 30, y: 0, w: 300 }, { x: 360, y: 0, w: 300 }, { x: 20, y: 320, w: 300 }, { x: 360, y: 320, w: 300 }],
  [{ x: 120, y: 0, w: 220 }, { x: 360, y: 0, w: 220 }, { x: 40, y: 240, w: 220 }, { x: 440, y: 240, w: 220 }, { x: 240, y: 390, w: 220 }],
  [
    { x: 30, y: 80, w: 200 }, { x: 240, y: 80, w: 200 }, { x: 450, y: 80, w: 200 },
    { x: 30, y: 380, w: 200 }, { x: 240, y: 380, w: 200 }, { x: 450, y: 380, w: 200 },
  ],
];

class P1 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tableColumns: [],
      tableList: [],
      chartTitle: [],
      chartList: [],
      tableColorList: [],
      chartColorList: [],
    }
  }

  fillColor = (tableColumns, tableColorList) => {
    return tableColumns.map(item => {
      return {
        ...item,
        style: {
          ...item.style,
          background: tableColorList[0],
        },
        colStyle: (val, index) => ({
          ...item.colStyle,
          background: index % 2 === 1 ? (tableColorList[1] || '#eaeffa') : (tableColorList[2] || '#d2ddf5'),
        })
      }
    })
  }

  render() {
    const { tableColumns, tableList, chartList, chartColorList, tableColorList } = this.state;
    const iPosition = positionList[(chartList.length || 1) - 1];

    return (
      <Stage>
        <Title1 pageNumber="3.1">
          显差 - <span className={s.emphasis}>红区</span>自媒体月度变化趋势
        </Title1>

        <div className={s.wrapper}>
          <div className={s.leftWrapper}>
            <h2 className={s.subTitle} contentEditable="true">
              <span className={s.subTriangle} />
              本月，红区账号共有<span className={s.subTitleEmphasis}>51</span>个，
              比上月减少<span className={s.subTitleEmphasis}>12</span>个。
            </h2>
            <TooltipDrawer formContent={<Form onChange={values => this.setState({ ...values })} />}>
              <DBTable columns={this.fillColor(tableColumns, tableColorList)} data={tableList} />
            </TooltipDrawer>
          </div>
          <div className={s.rightWrapper}>
            <div style={{ display: 'flex', height: '100%', position: 'relative' }}>
              {chartList.map((item, index) => (
                <div key={`${iPosition.w}_${index}`} style={{
                  position: 'absolute',
                  width: iPosition[index].w || 200,
                  height: iPosition[index].w || 200,
                  left: iPosition[index].x,
                  top: iPosition[index].y,
                }}>
                  <Chart options={setChart({ ...item, color: chartColorList })} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P1);



// WEBPACK FOOTER //
// src/routes/visualChart/P2/index.js